import React, { memo } from 'react';
import {
  string, number, bool, object,
} from 'prop-types';
import Locale from '@active/react-utils/i18n/Locale';
import AmountField from '../../../staticFields/AmountField';
import TipAmountField from '../../../staticFields/TipAmountField';
import Currency from '../../../Currency';
import CommonOrderAmountsItems from './CommonOrderAmountsItems';

const OrderAmounts = ({
  currencyCode, pennyRoundingAmount, grandTotal,
  totalAmount, paidAmount, remainingBalance, trackingCallback, vatAmount, isShowVatAmount,
  isShowBlankCol, fieldConfig, paymentProcessingFeeTotalAmount, ...rest
}) => {
  return (
    <div className="order-detail__content-amount">
      <CommonOrderAmountsItems
        currencyCode={currencyCode}
        fieldConfig={fieldConfig}
        isShowBlankCol={isShowBlankCol}
        trackingCallback={trackingCallback}
        {...rest} />
      <TipAmountField
        label="checkout.lib.components.text.totalPPF"
        tipId="checkout.lib.components.text.processingFeeCharged"
        price={paymentProcessingFeeTotalAmount}
        fieldType={'paymentProcessingFee'}
        trackingCallback={trackingCallback}
        currencyCode={currencyCode}
        {...fieldConfig}
        isShowBlankCol={isShowBlankCol}/>
      <AmountField label="checkout.lib.components.text.orderTotal"
        price={totalAmount}
        className="order-detail__content-amount__total"
        currencyCode={currencyCode}
        {...fieldConfig}
        isShowBlankCol={isShowBlankCol}/>
      {vatAmount && isShowVatAmount && <div className='order-detail__content-amount__vat'>
        <Locale id="checkout.lib.components.orderDetailContent.vatAmount.prefix" />
        {' '}
        <Currency amount={vatAmount} code={currencyCode}/>
      </div>}
      <AmountField label="checkout.lib.components.orderDetailContent.paidAmount"
        price={paidAmount}
        currencyCode={currencyCode}
        {...fieldConfig}
        isShowBlankCol={isShowBlankCol}/>
      <AmountField label="checkout.lib.components.orderDetailContent.remainingBalance"
        price={remainingBalance}
        className="order-detail__content-amount__remainbalance"
        currencyCode={currencyCode}
        {...fieldConfig}
        isShowBlankCol={isShowBlankCol}/>
      <AmountField label="checkout.lib.components.text.pennyRounding"
        price={pennyRoundingAmount}
        currencyCode={currencyCode}
        {...fieldConfig}
        isShowBlankCol={isShowBlankCol}/>
      <AmountField label="checkout.lib.components.text.grandTotal"
        price={grandTotal}
        className="order-detail__content-amount__grandTotal"
        currencyCode={currencyCode}
        {...fieldConfig}
        isShowBlankCol={isShowBlankCol}/>
    </div>
  );
};

OrderAmounts.propTypes = {
  currencyCode: string.isRequired,
  processingFee: number,
  totalAmount: number,
  paidAmount: number,
  remainingBalance: number,
  vatAmount: number,
  isShowVatAmount: bool,
  fieldConfig: object,
};

OrderAmounts.defaultProps = {
  isShowVatAmount: false,
  fieldConfig: {},
};

export default memo(OrderAmounts);
